import {
  PayableStatus,
  PayerApprovalStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The four batch statuses the payer picks from when creating a payables import.
 *
 * v1 had a single `BulkPayableStatus` covering all four. v3 splits the same
 * ground across `payableStatus` and `payerApprovalStatus`, so the option the
 * user picks maps to a pair.
 */
export enum PayableImportBatchStatus {
  Draft = "Draft",
  Open = "Open",
  Approved = "Approved",
  Paid = "Paid"
}

type PayableImportBatchStatusConfiguration = {
  payableStatus: PayableStatus;
  payerApprovalStatus?: PayerApprovalStatus;
};

export const PAYABLE_IMPORT_BATCH_STATUS_CONFIGURATION: Record<
  PayableImportBatchStatus,
  PayableImportBatchStatusConfiguration
> = {
  [PayableImportBatchStatus.Draft]: {
    payableStatus: PayableStatus.CREATED
  },
  [PayableImportBatchStatus.Open]: {
    payableStatus: PayableStatus.OPENED,
    payerApprovalStatus: PayerApprovalStatus.PENDING
  },
  [PayableImportBatchStatus.Approved]: {
    payableStatus: PayableStatus.OPENED,
    payerApprovalStatus: PayerApprovalStatus.APPROVED
  },
  [PayableImportBatchStatus.Paid]: {
    payableStatus: PayableStatus.PAID_OFF_PLATFORM
  }
};
